import { useApolloClient } from "@apollo/client"
import { useDispatch } from "react-redux";
import { ClienteDsCloudDataSource } from "../../data/datasources/ClienteDsCloud.datasource";
import { paramsGetClientesDsCloud, paramsSetEstadoCuentaPorSuscrip } from "../../bussines/params/ClienteDsCloud.params";
import { loadingModal } from "src/redux-app";
import { toast } from 'lib.front';

export const useClienteDsCloud = () => {
    const apolloClient = useApolloClient();
    const dispatch = useDispatch();
    const dataSource = new ClienteDsCloudDataSource(apolloClient);
    const getClientesDsCloud = async (params: paramsGetClientesDsCloud) => {
        try {
            dispatch(loadingModal(true));
            const response = await dataSource.getClientesDsCloud(params);
            if (response === null) {
                throw new Error('Error al consultar, vuelva a intentar en unos minutos');
            }
            return response;
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            toast.showError(message);
            return undefined;
        } finally {
            dispatch(loadingModal(false));
        }
    };
    const setEstadoCuentaPorSuscrip = async (params: paramsSetEstadoCuentaPorSuscrip) => {
        try {
            dispatch(loadingModal(true));
            const response = await dataSource.setEstadoCuentaPorSuscrip(params);
            return response;
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            toast.showError(message);
            return undefined;
        } finally {
            dispatch(loadingModal(false));
        }
    }
    return { getClientesDsCloud, setEstadoCuentaPorSuscrip };
}